import { defineMessages } from "react-intl";

export default defineMessages({
  impactTitle: {
    id: "realisationRate.impactTitle",
    defaultMessage: "Impact de votre taux de réalisation",
  },
  impactInfos: {
    id: "realisationRate.impactInfos",
    defaultMessage:
      "Une annulation peut arriver. Tant que cela reste <bold>rare</bold>, rien ne changera pour vous. Si cela devient trop fréquent, nous pourrions <bold>suspendre votre compte temporairement</bold>, et ce pour garantir la meilleure expérience à nos utilisateurs.",
  },
  seeMore: {
    id: "realisationRate.seeMore",
    defaultMessage: "Voir plus <RightIcon></RightIcon>",
  },
  jobsInProgress: {
    id: "realisationRate.jobsInProgress",
    defaultMessage: "Jobs en cours",
  },
  jobsAvailable: {
    id: "realisationRate.jobsAvailable",
    defaultMessage: "{maxInProgressServices} disponibles",
  },
  blocked: {
    id: "realisationRate.blocked",
    defaultMessage:
      "Vous avez atteint la limite de jobs annulés. Suivez nos conseils pour vous améliorer pour pouvoir postuler à nouveaux à des jobs.",
  },
  warning: {
    id: "realisationRate.warning",
    defaultMessage:
      "Si d’autres jobs sont annulés et que vous atteignez un niveau insuffisant, vous ne pourrez plus postuler.",
  },
  jobsInProgressModalInfos: {
    id: "realisationRate.jobsInProgressModalInfos",
    defaultMessage:
      "Lorsque vous atteignez le nombre maximum de jobs en cours et que vous souhaitez en réaliser d'autres, vous devrez d'abord clôturer ceux en cours pour pouvoir en faire d’autres.",
  },
  becomeSuperTalent: {
    id: "realisationRate.becomeSuperTalent",
    defaultMessage: "Devenez SuperTalent",
  },
  becomeSuperTalentMessage: {
    id: "realisationRate.becomeSuperTalentMessage",
    defaultMessage:
      "<whiteBold></whiteBold> et accédez à un nombre illimité de jobs.",
  },
  unlimited_jobs: {
    id: "realisationRate.unlimitedJobs",
    defaultMessage: "Job illimité pour les SuperTalent",
  },
});
